// extracted by mini-css-extract-plugin
module.exports = {"lottie":"index_lottie__qFkqq","img":"index_img__fjTZ1"};